module.exports = __webpack_public_path__ + "media/Video 132.dda6dbe7.mp4";